/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClubLogo } from '../models/club-logo';
import { ClubLogoList } from '../models/club-logo-list';
import { clubLogotype } from '../fn/club-logo/club-logotype';
import { ClubLogotype$Params } from '../fn/club-logo/club-logotype';
import { deleteClubLogotype } from '../fn/club-logo/delete-club-logotype';
import { DeleteClubLogotype$Params } from '../fn/club-logo/delete-club-logotype';
import { getClubLogotype } from '../fn/club-logo/get-club-logotype';
import { GetClubLogotype$Params } from '../fn/club-logo/get-club-logotype';
import { getClublogotypesList } from '../fn/club-logo/get-clublogotypes-list';
import { GetClublogotypesList$Params } from '../fn/club-logo/get-clublogotypes-list';

@Injectable({ providedIn: 'root' })
export class ClubLogoService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getClubLogotype()` */
  static readonly GetClubLogotypePath = '/clublogotypes/{logoId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClubLogotype()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClubLogotype$Response(params: GetClubLogotype$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = getClubLogotype(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getClubLogotype$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClubLogotype(params: GetClubLogotype$Params, context?: HttpContext): Observable<void> {
    const resp = this.getClubLogotype$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getClublogotypesList()` */
  static readonly GetClublogotypesListPath = '/clublogotypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClublogotypesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClublogotypesList$Response(params?: GetClublogotypesList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClubLogoList>>> {
    const obs = getClublogotypesList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getClublogotypesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClublogotypesList(params?: GetClublogotypesList$Params, context?: HttpContext): Observable<Array<ClubLogoList>> {
    const resp = this.getClublogotypesList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ClubLogoList>>): Array<ClubLogoList> => r.body)
    );
  }

  /** Path part for operation `clubLogotype()` */
  static readonly ClubLogotypePath = '/clublogotypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clubLogotype()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  clubLogotype$Response(params: ClubLogotype$Params, context?: HttpContext): Observable<StrictHttpResponse<ClubLogo>> {
    const obs = clubLogotype(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clubLogotype$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  clubLogotype(params: ClubLogotype$Params, context?: HttpContext): Observable<ClubLogo> {
    const resp = this.clubLogotype$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ClubLogo>): ClubLogo => r.body)
    );
  }

  /** Path part for operation `deleteClubLogotype()` */
  static readonly DeleteClubLogotypePath = '/clublogotypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteClubLogotype()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteClubLogotype$Response(params: DeleteClubLogotype$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteClubLogotype(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteClubLogotype$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteClubLogotype(params: DeleteClubLogotype$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteClubLogotype$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
